export default __webpack_public_path__ + "images/WaterletHandFill-Regular.font.283ec2818095d1cea0b437823753561c.svg";